import React from "react";
import ShipmentExternalAPISettings from "../Configuration/Shipment/ShipmentExternalAPISettings";
import PaymentTab from "../Payment/PaymentTab";

const IntegrationTab: React.FC = () => {
  return (
    <div className="space-y-8 font-body tracking-wider">
        {/* Integration Header */}
    <div>
      <h2 className="text-lg font-semibold text-gray-900">
        Integration
      </h2>
      <p className="text-sm text-gray-500 mt-1">
        Manage external service integrations
      </p>
    </div>

      {/* SHIPPING + WHATSAPP */}
      <div>
        {/* <h3 className="text-sm font-medium">Shipping</h3> */}
        {/* <p className="text-xs text-gray-500 mt-1">
          Configure shipping and WhatsApp integrations
        </p> */}
        <ShipmentExternalAPISettings />
      </div>

      {/* PAYMENT */}
      <div className="pt-6 border-t">
        <h3 className="text-sm font-medium">Payment</h3>
        <p className="text-xs text-gray-500 mt-1">
          Configure payment gateway settings
        </p>
        <PaymentTab />
      </div>

    </div>
  );
};

export default IntegrationTab;
